import { useAppDispatch } from 'legacy/lut/hooks/useAppDispatch'
import { useEffect } from 'react'
import { useSelector } from 'react-redux'

import type { TAttentionStatusMode } from 'partner360/entities/attentionStatuses'

import { resetCockpitAttentionDrill } from '../../../model/financialCockpitSlice'
import { selectCockpitAttentionCockpitMode } from '../../../model/selectors'

/**
 * Claims the shared drill-down for the cockpit the tile is rendering in, and reports whether it
 * already belongs to it.
 *
 * One slice holds the drill-down for both cockpits — the collapsed and the expanded tile are
 * separate component trees, so component state cannot. The two catalogs share their `BitValue`s,
 * so a status picked in one cockpit would resolve in the other and open a detail nobody asked
 * for; entering a cockpit therefore drops what the other one left behind.
 */
export const useAttentionDrillMode = (cockpitMode: TAttentionStatusMode): boolean => {
  const dispatch = useAppDispatch()
  const storedMode = useSelector(selectCockpitAttentionCockpitMode)
  const isOwnDrill = storedMode === cockpitMode

  useEffect(() => {
    if (!isOwnDrill) {
      dispatch(resetCockpitAttentionDrill(cockpitMode))
    }
  }, [cockpitMode, dispatch, isOwnDrill])

  return isOwnDrill
}
